import { Box, Grid, Tooltip } from '@mui/material'
import React from 'react'
import DropDownV3 from '../../../common/DropDownV3'
import TooltipPickUpAndDropOff from '../TooltipPickUpAndDropOff'
import InfoIcon from '../../../assets/Icons/InfoIcon'

const PickUpAndDropOff = (props) => {
    const { filterOpt, bkgDeatails, setBkgDetails, selectedSeat = [] } = props
    const pickUpProps = () => {
        return {
            width: "100%",
            name: "PickUp",
            id: 'PickUp',
            label: "PickUp",
            isCompulsory: false,
            options: filterOpt?.pickUp || [],
            preSelectedValues: bkgDeatails?.pickUp || [],
            searchPlaceholder: "Search by PickUp",
            disabled: false,
            isObject: true,
            primaryKey: 'pickup_id',
            labelKey: 'label',
            singleSelect: true,
            direction: "up",
            nextId: 'DropOff',
            prevId: `addRemove_seat_btn-${selectedSeat?.length - 1}`,


        }
    }

    const handlePickUp = (val) => {
        setBkgDetails((prev) => ({
            ...prev,
            pickUp: val
        }))
    }
    const DropOffProps = () => {
        return {
            width: "100%",
            name: "DropOff",
            id: 'DropOff',
            label: "DropOff",
            isCompulsory: false,
            options: filterOpt?.dropOff || [],
            preSelectedValues: bkgDeatails?.dropOff || [],
            searchPlaceholder: "Search by DropOff",
            disabled: false,
            isObject: true,
            primaryKey: 'DropoffId',
            labelKey: 'label',
            singleSelect: true,
            direction: "up",
            nextId: bkgDeatails?.isDisableRemarks ? 'paymentMode' : 'remarks',
            prevId: `PickUp`,
            directionX: 'left',

        }
    }


    const handleDropOff = (val) => {
        setBkgDetails((prev) => ({
            ...prev,
            dropOff: val
        }))
    }
    return (
        <Box className='pickUpAndDropOff_page'>
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                flexWrap={'wrap'}
                alignItems="stretch"
                sx={{ padding: '0px' }}
                columnSpacing={{ xs: '8px' }}
                rowSpacing={{ xs: '12px' }}
            >
                <Grid item size={6} className='smallDropDownp28'>
                    <Box sx={{ display: 'flex', alignItems: "center", gap: "8px" }}>
                        <Box sx={{ flex: 1 }}>
                            <DropDownV3
                                {...pickUpProps()}
                                onSelect={handlePickUp}
                            />
                        </Box>
                        <Box>
                            <Tooltip

                                PopperProps={{

                                    modifiers: [
                                        { name: 'offset', options: { offset: [0, 0] } },
                                        { name: 'arrow', options: { padding: 10 } },
                                        {
                                            name: 'preventOverflow',
                                            options: {
                                                boundary: 'viewport'
                                            }
                                        },
                                        {
                                            name: 'flip',
                                            options: {
                                                fallbackPlacements: ['left-end'],
                                            }
                                        }
                                    ],
                                    sx: {
                                        '& .MuiTooltip-tooltip': {
                                            backgroundColor: 'transparent',
                                            boxShadow: 'none',
                                            padding: 0,
                                            zIndex: 1400,
                                            minWidth: '400px'
                                        },
                                        '& .MuiTooltip-arrow': {
                                            color: '#FAF9F6',
                                            width: '22px',
                                            height: '13px',
                                        },
                                        '&[data-popper-placement^="bottom"] .MuiTooltip-arrow': {
                                            color: '#0086FF',
                                        },
                                    },
                                }}
                                title={
                                    <TooltipPickUpAndDropOff
                                        columnDef={[
                                            {
                                                name: 'PickupName',
                                                value: bkgDeatails?.pickUp?.[0]?.pickup_name || '',
                                            },
                                            {
                                                name: 'PickupAddress',
                                                value: bkgDeatails?.pickUp?.[0]?.pickup_address || '',
                                            },
                                            {
                                                name: 'Landmark',
                                                value: bkgDeatails?.pickUp?.[0]?.pickup_landmark || '',
                                            },
                                            {
                                                name: 'Contact Nos',
                                                value: bkgDeatails?.pickUp?.[0]?.pickup_phone || '',
                                            },
                                            {
                                                name: 'Time',
                                                value: bkgDeatails?.pickUp?.[0]?.pickup_time || '',
                                            },
                                        ]}
                                    />
                                }
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                    <InfoIcon width={20} height={20} />
                                </Box>
                            </Tooltip>
                        </Box>
                    </Box>
                </Grid>

                <Grid item size={6} className='smallDropDownp28'>
                    <Box sx={{ display: 'flex', alignItems: "center", gap: "8px" }}>
                        <Box sx={{ flex: 1 }}>
                            <DropDownV3
                                {...DropOffProps()}
                                onSelect={handleDropOff}
                            />
                        </Box>
                        <Box>
                            <Tooltip
                                PopperProps={{
                                    modifiers: [
                                        { name: 'offset', options: { offset: [0, 0] } },
                                        { name: 'arrow', options: { padding: 10 } },
                                        {
                                            name: 'preventOverflow',
                                            options: {
                                                boundary: 'viewport'
                                            }
                                        },
                                        {
                                            name: 'flip',
                                            options: {
                                                fallbackPlacements: ['left-end'],
                                            }
                                        }
                                    ],
                                    sx: {
                                        '& .MuiTooltip-tooltip': {
                                            backgroundColor: 'transparent',
                                            boxShadow: 'none',
                                            padding: 0,
                                            zIndex: 1400,
                                            minWidth: '400px'
                                        },
                                        '& .MuiTooltip-arrow': {
                                            color: '#FAF9F6',
                                            width: '22px',
                                            height: '13px',
                                        },
                                        '&[data-popper-placement^="bottom"] .MuiTooltip-arrow': {
                                            color: '#0086FF',
                                        },
                                    },
                                }}
                                title={
                                    <TooltipPickUpAndDropOff
                                        columnDef={[
                                            {
                                                name: 'DropOffName',
                                                value: bkgDeatails?.dropOff?.[0]?.DropoffName || '',
                                            },
                                            {
                                                name: 'Drop Time',
                                                value: bkgDeatails?.dropOff?.[0]?.DropoffTime || '',
                                            },
                                        ]}
                                    />
                                }
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                    <InfoIcon width={20} height={20} />
                                </Box>
                            </Tooltip>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}

export default PickUpAndDropOff